<template>
  <div id="app">
    <PasswordPrompt>
      <address-input></address-input>
    </PasswordPrompt>
  </div>
</template>

<script>
import PasswordPrompt from './components/PasswordPrompt.vue';
import AddressInput from './components/AddressInput';

export default {
  name: 'App',
  components: {
    PasswordPrompt,
    AddressInput
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
